import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Box,
  Typography,
  TableHead,
  Card,
} from "@mui/material";
import Paginations from "../../common/pagination/Paginations";
import { handleContactedPersonApi } from '../../api';
import { useSelector } from 'react-redux';
import Loader from '../../common/loader/Loader';
import UserContactedRow from '../../common/tablerow/UserContactedRow';
import TableComp from '../../common/tablecomp/TableComp';

const UserContactedList = () => {
  
  const token = useSelector((state) => state?.user?.user?.token);
  const [contactedData, setContactedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages,setTotalPages]=useState()
  const [currentPage,setCurrentPage]=useState(1)



  const allContactedList = async () => {
    try {
      setLoading(true);
      const response = await handleContactedPersonApi({token,currentPage});
      setContactedData(response?.contacts || []);
      setCurrentPage(parseInt(response?.currentPage))
      setTotalPages(response?.totalPages)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    allContactedList();
  }, [currentPage]);
  
  // useEffect(() => {
  //   allContactedList();
  // }, []);

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };
  
  
  const titles = [
    { title: "Name" },
    { title: "Email" },
    { title: "Phone No" },
    { title: "Message" },
    { title: "Date" },
  ];


  return (
    <div>
      {loading ? (
       
          <Loader variant="table" />
      
      ) : (
        <Card
        backgroundColor={"#fff"}
        borderRadius={"35px"}
        sx={{ padding: "20px", borderRadius: "25px",marginTop: "40px", marginBottom: "30px"  }}
      >
        <TableComp title={titles}>
          {contactedData?.length > 0 ? (
            contactedData?.map((item) => (
              <UserContactedRow 
                key={item?._id}
                row={item}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={titles.length} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          )}
        </TableComp>

        <Paginations
         totalPages={totalPages}
         currentPage={currentPage}
         onPageChange={handlePageChange}
         disabled={loading}
        />
      </Card>
      )}
    </div>
  );
};

export default UserContactedList;
